import React, { useEffect } from "react";
import { useSocket } from "../../hooks/useSocket";
import useUserStore from "../../stores/store";
import { updateLayoutFloorsFromSocket } from "../../utils/store-mutator.table-management";

const SocketTableLayout = ({}) => {
  const socket = useSocket(`${process.env.REACT_APP_IMAGE_BASE_URL}`);
  const { restaurantSlug, tableManagement } = useUserStore();

  useEffect(() => {
    // setNewOrderId('');
    // setShouldFetchOrderRecords(true);
    // setShouldFetchDashboardOrders(true);
    // setOrderRecordsFilter(getOrderDefaultFilter());
    // setOrderRecords([]);
    // setDashboardOrders([]);
  }, []);

  useEffect(() => {
    if (!socket || !restaurantSlug || tableManagement !== 'Active') {
      return;
    }

    // New Order Placed
    const eventName = `${restaurantSlug}-update-floor-layout`;
    socket.on(eventName, (data) => {
        console.log(`===========${eventName}==socket received`, {data})
        updateLayoutFloorsFromSocket(data);
    });
  }, [socket, restaurantSlug, tableManagement]);

  return <></>;
};

export default SocketTableLayout;
